/**
 * 파일명 : usr0302p1.tsx
 * 설명   : 경력관리 > 기술등급(팝업화면)
 * 수정내역
 ************************************************
 * Version    수정일자      수정자    수정내용      
 ************************************************
 * 1.0       2026-03-24    김시현    최초작성
 *     
 */
/************************************************
 * Import 영역  
 ************************************************/

/*  React  */
import React from 'react';

/*  AntD  */
import { Layout, Table, Divider } from 'antd'; // Ant Design(antd)에서 컴포넌트 호출

const Usr0302p1 = (props:any) => {

    /* Render 변수 선언영역 */
    /* AntD */
    const { Content } = Layout;

    /************************************************
    * 전역변수 선언영억
    ************************************************/
    /* Table Data */
    const workExpreList = {
        List : [
            { rank: '특급 기술자', range1: '108 이상', range2: '144 이상',  range3: '180 이상', range4: ''         },
            { rank: '고급 기술자', range1: '72~107'  , range2: '108~143' , range3: '144~179' , range4: '180 이상' },
            { rank: '중급 기술자', range1: '36~71'   , range2: '72~107'  , range3: '108~143' , range4: '144 이상' },
            { rank: '초급 기술자', range1: '36 미만' , range2: '72 미만' ,  range3: '108 미만', range4: '144 미만' }
        ]
    };

    /* Table Data */
    const workExpreList2 = {
        List : [
            { rank: '특급 기술자', range5: '120 이상', range6: '156 이상'  },
            { rank: '고급 기술자', range5: '84~120'  , range6: '120~156'  },
            { rank: '중급 기술자', range5: '48~84'   , range6: '84~120'   },
            { rank: '초급 기술자', range5: '48 미만' , range6: '84 미만'   }
        ]
    };

    /* Table Columns */
        const columns = React.useCallback(() => {
            const arr:any = [
                {
                    title: () => <div style={{ textAlign: "center" }}>구분</div>,
                    dataIndex: "rank",
                    key: "rank",
                    align: "center",
                    width: "20%",
                    // 첫번째 열 color 변경
                    onCell: () => ({
                    style: { backgroundColor: '#e8f4fc' },
                    }),
                },
                {
                    title: () => <div style={{ textAlign: "center" }}>석사</div>,
                    dataIndex: "range1",
                    key: "range1",
                    align: "center",
                    width: "20%",
                },
                {
                    title: () => <div style={{ textAlign: "center" }}>학사</div>,
                    dataIndex: "range2",
                    key: "range2",
                    align: "center",
                    width: "20%",
                },
                {
                    title: () => <div style={{ textAlign: "center" }}>전문학사</div>,
                    dataIndex: "range3",
                    key: "range3",
                    align: "center",
                    width: "20%",
                },
                {
                    title: () => <div style={{ textAlign: "center" }}>고졸</div>,
                    dataIndex: "range4",
                    key: "range4",
                    align: "center",
                    width: "20%",
                }
                ];
            return arr;
        }, []);

        /* Table Columns */
        const columns2 = React.useCallback(() => {
            const arr:any = [
                {
                    title: () => <div style={{ textAlign: "center" }}>구분</div>,
                    dataIndex: "rank",
                    key: "rank",
                    align: "center",
                    width: "20%",
                    // 첫번째 열 color 변경
                    onCell: () => ({
                    style: { backgroundColor: '#e8f4fc' },
                    }),
                },
                {
                    title: () => <div style={{ textAlign: "center" }}>기사</div>,
                    dataIndex: "range5",
                    key: "range5",
                    align: "center",
                    width: "20%",
                },
                {
                    title: () => <div style={{ textAlign: "center" }}>산업기사</div>,
                    dataIndex: "range6",
                    key: "range6",
                    align: "center",
                    width: "20%",
                }
                ];
            return arr;
        }, []);

    /* 화면 디자인 영역 */
    return (
        <Layout>
            <Divider style={{ margin: "2px" }}/>
            <div style={{ display:'flex' }}>
                <div className="ant-space css-dev-only-do-not-override-mncuj7 ant-space-horizontal ant-space-align-center ant-space-gap-row-small ant-space-gap-col-small" style={{ textAlign: "left", width:"80%" }}>
                    <div className='ant-space-item'>
                        <img className='title-icon' alt='' />
                    </div>
                    <div>학력경험기준</div>
                </div>
                
                <div style={{ textAlign: "right", padding: "5px", color: "gray", width:"20%" }}>
                    ( 단위: 개월수 )
                </div>
            </div>
            <Content>
                <Table
                    dataSource={workExpreList.List}
                    columns={columns()}
                    size='small'
                    style={{width:'100%'}}
                    pagination={false}
                />
            </Content>

            <div style={{ display:'flex' }}>
                <div className="ant-space css-dev-only-do-not-override-mncuj7 ant-space-horizontal ant-space-align-center ant-space-gap-row-small ant-space-gap-col-small" style={{ textAlign: "left", width:"80%" }}>
                    <div className='ant-space-item'>
                        <img className='title-icon' alt='' />
                    </div>
                    <div>기술자격기준</div>
                </div>
                
                <div style={{ textAlign: "right", padding: "5px", color: "gray", width:"20%" }}>
                    ( 단위: 개월수 )  
                </div>
            </div>
            <Content>
                <Table
                    dataSource={workExpreList2.List}
                    columns={columns2()}
                    size='small'
                    style={{width:'100%'}}
                    pagination={false}
                />
            </Content>
        </Layout>
    );

};

export default Usr0302p1;

